export default __webpack_public_path__ + "static/ballerina-6ad9cba6610564709807c5fe324cae65.webp";